import React from 'react'
import {Slide, Zoom, Snackbar} from '@material-ui/core'
import {Alert} from '@material-ui/lab'

function SlideTransition(props) {
  return <Slide {...props} direction="down" />
}
function ZoomTransition(props) {
  return <Zoom {...props} />
}

function ToastMessage(props) {
  const e = props
  const {index, handleClose, handleExited} = e
  return (
    <Snackbar
      style={{zIndex: 99999}}
      anchorOrigin={
        !e.elRef
          ? {vertical: 'top', horizontal: 'center'}
          : {vertical: 'bottom', horizontal: 'center'}
      }
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      key={index}
      open={e.show}
      autoHideDuration={3000}
      onClose={(e, r) => handleClose(e, r, index)}
      onExited={e => handleExited(e, index)}
      TransitionComponent={!e.elRef ? SlideTransition : ZoomTransition}
    >
      <Alert elevation={1} onClose={(e, r) => handleClose(e, r, index)} severity={e.severity}>
        {e.message}
      </Alert>
    </Snackbar>
  )
}

export default ToastMessage
